import { Browser } from "@capacitor/browser";
import type { RedirectLoginOptions } from "@auth0/auth0-react";
import { trackSignupScreenSeenAt } from "src/utils/analyticsCapFirebase";

// Redirects a NON-LOGGED user that ran out of free credits to the Auth0 login.
// Sends ext_no_credits=true so the Auth0 Universal Login shows the
// "Sign up for 100 free credits" message (only in this context, not on normal login).
// Web: same tab. Capacitor: in-app browser (same openUrl pattern used elsewhere).
export const redirectToAuth0NoCredits = async (
  loginWithRedirect: (options?: RedirectLoginOptions) => Promise<void>
): Promise<void> => {
  await trackSignupScreenSeenAt("free_limit_reached", "no_credits");
  await loginWithRedirect({
    authorizationParams: {
      ext_no_credits: "true",
    },
    async openUrl(url: string) {
      await Browser.open({
        url,
        windowName: "_self",
      });
    },
  });
};
